const url = window.location.host;
const bloodstockLogoString =
`<a href="https://${url}/bloodstock" class="rn-menuBar__logo__link"` +
'title="Racing Post Home" data-test-selector="link-navigationRpLogo">' +
'<svg class="rn-menuBar__logo__img" xmlns="http://www.w3.org/2000/svg" \n' +
'     viewBox="0 0 256 25"\n' +
'     style="display: block; width: 100%;">\n' +
'    <g fill="none" fill-rule="evenodd">\n' +
'        <path d="M-8-8h397.808v39.933H-8z"/>\n' +
'        <path fill="#FFF"\n' +
'              d="M19.201 12.731c0 3.705-3.047 6.708-' +
'6.805 6.708-3.76 0-6.807-3.003' +
'-6.807-6.708 0-3.706 3.047-6.71 6.807-6.71 3.758 0 6.805 3.004 6.805 6.71z"/>\n' +
'        <path fill="#ED1C24"\n' +
'              d="M12.394 19.29c-3.658 0-6.623-2.923-' +
'6.623-6.528 0-3.607 2.965-6.529 ' +
'6.623-6.529 3.583 0 6.499 2.802 6.618 6.305-.006-4.99' +
'6-.01-9.92-.005-10.005A12.374 12.374 0' +
' 0 0 12.394.631C5.598.631.088 6.061.088 12.762c0 6.7 5.51 12.13' +
' 12.306 12.13 2.443 0 4.718-.705 ' +
'6.633-1.915l-.014-10.012c-.11 3.51-3.03 6.324-6.619 6.324z"/>\n' +
'        <path fill="#D872AD"\n' +
'              d="M21.781 20.601l.09-.1c.145-.173.285-.35.42-.53.0' +
'38-.052.074-.105.113-.156.096-.133.191-.27.282-.406.044-.068.088-' +
'.134.13-.202.086-.132.168-.269.249-.405l.11-.188c.11-.198.215-.39' +
'6.314-.6.014-.027.025-.055.039-.083.085-.178.167-.36.243-.542.03-.' +
'071.058-.146.088-.219.057-.145.11-.289.163-.436.028-.08.055-.157.08-' +
'.235.053-.164.103-.327.15-.493.015-.059.035-.117.05-.177.058-.22.11-.' +
'444.157-.669.013-.066.023-.13.035-.194a11.413 11.413 0 0 0 .165-1.251' +
'c.006-.076.013-.152.018-.23.014-.239.023-.48.023-.722 0-.246-.01-.488' +
'-.024-.728-.005-.073-.01-.146-.017-.22-.013-.17-.03-.34-.05-.509l-.03' +
'-.236a12.507 12.507 0 0 0-.09-.532c-.01-.057-.018-.115-.03-.171-.047-.2' +
'29-.1-.456-.159-.68l-.047-.163a14.611 14.611 0 0 0-.231-.733 12.7 12.7 ' +
'0 0 0-.17-.45c-.027-.07-.053-.14-.082-.208-.083-.197-.169-.39-.26-.58-.' +
'009-.016-.016-.033-.023-.048-.1-.205-.206-.404-.316-.601l-.113-.193a11.' +
'52 11.52 0 0 0-.66-1.009l-.114-.159a12.812 12.812 0 0 0-.417-.524l-.118' +
'-.133c-.11-.128-.223-.254-.339-.377-.056-.06-.113-.116-.17-.175a13.664 ' +
'13.664 0 0 0-.5-.483 11.579 11.579 0 0 0-.45-.391l-.064-.056a12.323 12.' +
'323 0 0 0-.538-.41c-.058-.043-.118-.083-.177-.125a14.33 14.33 0 0 0-.4' +
'-.27l-.105-.066c-.005.085 0 5.01.006 10.005.003.075.005.15.005.224 0 ' +
'.069-.002.136-.005.204l.014 10.011.096-.06c.14-.09.278-.184.415-.281.' +
'052-.037.106-.073.158-.111.185-.135.366-.272.542-.417l.074-.062a11.755 ' +
'11.755 0 0 0 .946-.875 12.356 12.356 0 0 0 .524-.57z"/>\n' +
'        <g fill="#D872AD">\n' +
'            <path fill-rule="nonzero"\n' +
'                  d="M27.54 24.549V1.042h13.515c4.755 0 6.972 3.03 ' +
'6.972 5.99 0 2.925-1.823 4.899-4.076 5.392 2.539.387 4.54 2.784 4.54 5.745' +
' 0 3.418-2.323 6.38-7.007 6.38H27.541zM41.77 8.16c0-1.128-.858-1.834-2.108-' +
'1.834H33.69v3.667h5.97c1.251 0 2.11-.67 2.11-1.833zm.465 9.093c0-1.165-.857-' +
'1.974-2.36-1.974H33.69v3.983h6.186c1.466 0 2.36-.741 2.36-2.01z"/>\n' +
'            <path d="M50.547 24.549V1.042h6.15v18.22h9.581v5.286H50.547z"/>\n' +
'            <path fill-rule="nonzero"\n' +
'                  d="M65.366 12.812c0-7.153 5.472-12.158 12.765-12.158s12.727' +
' 5.005 12.727 12.158c0 7.155-5.434 12.158-12.727 12.158s-12.' +
'765-5.003-12.765-12.158zm19' +
'.235 0c0-3.84-2.538-6.801-6.47-6.801-3.933 0-6.508 2.961-6.5' +
'08 6.8 0 3.807 2.575 6.8' +
'03 6.508 6.803 3.932 0 6.47-2.996 6.47-6.802zM92.02 12.812c0-7.153 5.47-' +
'12.158 12.763-12.158 7.294 0 12.73 5.005 12.73 12.158 0 7.155-5.436 12.' +
'158-12.73 12.158-7.293 0-12.763-5.003-12.763-12.158zm19.235 0c0-3.84-2.5' +
'39-6.801-6.472-6.801-3.933 0-6.507 2.961-6.507 6.8 0 3.807 2.574 6.803 6' +
'.507 6.803 3.934 0 6.472-2.996 6.472-6.802zM119.323 24.549V1.042h10.009c7.' +
'508 0 12.904 4.44 12.904 11.736 0 7.294-5.396 11.77-12.869 11.77h-10.044zm16' +
'.624-11.771c0-3.632-2.217-6.45-6.58-6.45h-3.895v12.935h3.86c4.183 0 6.6' +
'15-2.996 6.615-6.485z"/>\n' +
'            <path d="M142.673 21.235l3.252-4.722a10.87 10.87 0 0 0 7.651 3.101' +
'c2.072 0 3.361-.705 3.361-1.868 0-3.1-13.479-.528-13.479-9.585 0-3.947 3.' +
'36-7.472 9.474-7.472 3.825 0 7.15 1.128 9.689 3.28l-3.362 4.545c-2-1.658-4.6' +
'12-2.468-6.971-2.468-1.787 0-2.575.6-2.575 1.622 0 2.888 13.478.704 13.478 ' +
'9.444 0 4.722-3.536 7.858-9.937 7.858-4.827 0-8.187-1.515-10.581-3.735zM170.' +
'533 24.549V6.328h-6.684V1.042h19.485v5.285h-6.653v18.221h-6.148z"/>\n' +
'            <path fill-rule="nonzero"\n' +
'                  d="M182.899 12.812c0-7.153 5.47-12.158 12.764-12.158s12' +
'.727 5.005 12.727 12.158c0 7.155-5.433 12.158-12.727 12.158-7.294 0-12.764' +
'-5.003-12.764-12.158zm19.236 0c0-3.84-2.54-6.801-6.472-6.801-3.934 0-6.506 ' +
'2.961-6.506 6.8 0 3.807 2.572 6.803 6.506 6.803 3.931 0 6.472-2.9' +
'96 6.472-6.802z"/>\n' +
'            <path d="M209.552 12.812c0-7.259 5.58-12.158 12.907-12.158 5.75' +
'6 0 8.868 3.207 10.405 6.272l-5.292 2.504c-.787-1.87-2.825-3.42-5.113-3.' +
'42-3.898 0-6.648 2.925-6.648 6.801 0 3.842 2.75 6.803 6.648 6.803 2.288 ' +
'0 4.326-1.551 5.113-3.417l5.292 2.466c-1.537 2.996-4.649 6.307-10.405 6.307' +
'-7.328 0-12.907-4.931-12.907-12.158zM248.423 24.549l-6.255-8.846-1.609 1.97' +
'2v6.873h-6.15V1.042h6.15v9.656l7.33-9.656h7.578l-9.26 10.994 9.761 12.513z"/>\n' +
'        </g>\n' +
'    </g>\n' +
'</svg>\n' +
'</a>';

export default bloodstockLogoString;



// WEBPACK FOOTER //
// ./src/js/horse/bloodstockLogoString.js